/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface BankTransactionCode {
  code: string;
  subCode: string;
}

export const bankTransactionCodeSchema: Schema<BankTransactionCode> = object({
  code: ['Code', string()],
  subCode: ['SubCode', string()],
});
